import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../lib/supabase';
import PlayerForm from '../components/players/PlayerForm';

interface Player {
  id: string;
  grupo_id: string;
  nome: string;
  idade?: number;
  tipo: string;
  posicao?: string;
  nivel: number;
  telefone?: string;
  foto_url?: string;
  referencia?: string;
  ativo: boolean;
}

const EditPlayerPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [player, setPlayer] = useState<Player | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlayer = async () => {
      if (!id || !user) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('jogadores')
          .select('*')
          .eq('id', id)
          .single();

        if (error) {
          throw error;
        }

        setPlayer(data);
      } catch (err) {
        console.error('Erro ao buscar jogador:', err);
        setError('Erro ao carregar dados do jogador');
      } finally {
        setLoading(false);
      }
    };

    fetchPlayer();
  }, [id, user]);

  if (!id || !user) {
    return null;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error || !player) {
    return (
      <div className="text-center py-8">
        <p className="text-red-600 dark:text-red-400 mb-4">
          {error || 'Jogador não encontrado'}
        </p>
        <button
          onClick={() => navigate('/jogadores')}
          className="btn btn-secondary"
        >
          Voltar para Jogadores
        </button>
      </div>
    );
  }

  return (
    <div>
      <header className="mb-8">
        <h1 className="text-2xl font-bold mb-2">Editar Jogador</h1>
        <p className="text-gray-500 dark:text-gray-400">
          Atualize as informações do jogador
        </p>
      </header>

      <div className="card p-6">
        <PlayerForm
          groupId={player.grupo_id}
          playerId={player.id}
          onCancel={() => navigate('/jogadores')}
        />
      </div>
    </div>
  );
};

export default EditPlayerPage;